// extracted by mini-css-extract-plugin
export default {"container":"oma-z","mediaElement":"pma-z","close":"qma-z"};